/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useHistory } from "react-router-dom";

import { SaveButton, useNotify } from "react-admin";
import { useForm, useFormState } from "react-final-form";

import { SaveIcon } from "../../../../components/common/iconography";
import { logError } from "../../../../utils/appUtils";
import { ResourceType } from "../../../../utils/constants";
import { deepRedirect, autogenHistoryNotes } from "../../../../utils/utils";
import { normalizeFreeCars, normalizeGraduatedRates } from "./ChargeRuleUtils";

export const DialogSaveButton = ({
  label,
  backPath,
  isDeleting,
  isSaving,
  setIsSaving,
  ...props
}) => {
  const form = useForm();
  const { pristine, submitting } = useFormState();
  const notify = useNotify();
  const history = useHistory();

  const transform = (data) => {
    data = { ...data };
    setIsSaving(true);
    autogenHistoryNotes(form, data.id, ResourceType.CHARGE_RULE);

    // Convert numeric fields - only if they have valid values
    if (data.minCharge != null && data.minCharge !== "")
      data.minCharge = parseFloat(data.minCharge);
    if (data.maxCharge != null && data.maxCharge !== "")
      data.maxCharge = parseFloat(data.maxCharge);
    if (!data.freeDays) data.freeDays = 0;
    data.freeCars = normalizeFreeCars(data);
    data.graduatedRates = normalizeGraduatedRates(data.graduatedRates);

    delete data.createdAt;
    delete data.history;
    delete data.reloadYardCommodity;
    delete data.service;
    delete data.updatedAt;

    return data;
  };

  // Free days are a property of this rule alone. A more specific rule (e.g.
  // scoped to a load type) may carry different free days than the catch-all
  // for the same service / area / zone, so peers are never written here.
  const onSuccess = () => {
    setIsSaving(false);
    notify("Rule updated successfully.", "success");
    deepRedirect(history, backPath);
  };

  const onFailure = (error) => {
    setIsSaving(false);
    logError("chargeRules:DialogSaveButton:onFailure", error, notify);
  };

  return (
    <SaveButton
      label={label}
      icon={<SaveIcon />}
      submitOnEnter={true}
      undoable={false}
      disabled={pristine || isSaving || isDeleting}
      saving={isSaving || submitting}
      handleSubmitWithRedirect={props.handleSubmitWithRedirect}
      transform={transform}
      onSuccess={onSuccess}
      onFailure={onFailure}
    />
  );
};
